import { type ReactNode } from 'react';
import {
  BODY,
  Bullet,
  Card,
  PullQuote,
  Section,
  Subsection,
} from './rules-typography';

function Empresas(): ReactNode {
  return (
    <Subsection title="Empresas">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>Librerías</Bullet>
        <Bullet>Bibliotecas</Bullet>
        <Bullet>Editoriales</Bullet>
      </ul>
    </Subsection>
  );
}

function Personas(): ReactNode {
  return (
    <Subsection title="Personas">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>Bookgramers (solo hablan de libros).</Bullet>
        <Bullet>Con libros visibles (aunque no hablen de libros).</Bullet>
        <Bullet>Personas interesantes (aunque no hablen de libros).</Bullet>
        <Bullet>Autor.</Bullet>
      </ul>
    </Subsection>
  );
}

export function Categories(): ReactNode {
  return (
    <Section title="Las categorías de creadores">
      <Card>
        <div className="space-y-md">
          <Empresas />
          <Personas />
        </div>
      </Card>
      <p className={BODY}>
        Requisito clave: tienen que ser cuentas{' '}
        <strong className="text-text-primary">hispanas</strong>.
      </p>
      <PullQuote>
        ¿Y si es autor + influencer de libros? Categoría <strong>Autor</strong>{' '}
        siempre.
      </PullQuote>
    </Section>
  );
}

export function WhatWeWant(): ReactNode {
  return (
    <Section title="3. Qué buscamos realmente">
      <p className={BODY}>
        No buscamos personas con muchos seguidores. Buscamos creadores de
        contenido que <em>lo vivan</em>.
      </p>
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>Se muestran en cámara.</Bullet>
        <Bullet>Hablan.</Bullet>
        <Bullet>Tienen energía de comunicar.</Bullet>
      </ul>
      <p className={BODY}>
        Mientras tengan al menos 10 publicaciones, da igual si tienen 100, 10K o
        10M seguidores.
      </p>
    </Section>
  );
}
